export function revealInitialFrameWhenReady(root: HTMLElement): void {
  const loader = document.querySelector<HTMLElement>("#boot-loader");
  if (!loader) return;

  let finished = false;
  const observer = new MutationObserver(checkScreen);
  const timeout = window.setTimeout(finish, 15000);

  function finish(): void {
    if (finished) return;
    finished = true;
    observer.disconnect();
    window.clearTimeout(timeout);
    loader!.classList.add("is-ready");
    window.setTimeout(() => {
      loader!.classList.add("is-hidden");
      window.setTimeout(() => loader!.remove(), 300);
    }, 260);
  }

  function checkScreen(): void {
    const screen = root.querySelector("main");
    if (!screen) return;
    const customHost = screen.querySelector<HTMLElement>(".custom-start-host");
    const customRoot = customHost?.shadowRoot;
    if (customRoot?.querySelector(".custom-start-loading")) {
      observer.observe(customRoot, { childList: true, subtree: true });
      return;
    }
    observer.disconnect();
    const content = customRoot ?? screen;
    const images = Array.from(content.querySelectorAll<HTMLImageElement>("img")).filter((image) => {
      const bounds = image.getBoundingClientRect();
      return image.loading !== "lazy" && bounds.top < window.innerHeight && bounds.bottom > 0;
    });
    void Promise.all(images.map((image) => image.decode().catch(() => undefined))).then(() => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(finish));
    });
  }

  observer.observe(root, { childList: true, subtree: true });
  checkScreen();
}
